module.exports = "../images/fishing-lodge-17.jpg?v=9d18f0b";